import { createAction, props } from "@ngrx/store";
import { SelectableLanguages } from "../../models/state/profile/profile-state";

export namespace ProfileStateAction {

  export const setLanguage = createAction(
    '[ProfileState] setLanguage',
    props<{
      language: SelectableLanguages,
    }>()
  )
  // Saves the language on the auth server user. setLanguage only changes this browser.
  export const saveLanguage = createAction(
    '[ProfileState] saveLanguage',
    props<{
      language: SelectableLanguages,
    }>()
  )
  export const setName = createAction(
    '[ProfileState] setName',
    props<{
      name: string,
    }>()
  )
  export const setEmail = createAction(
    '[ProfileState] setEmail',
    props<{
      email: string,
    }>()
  )
}
